import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../../axios";
import "dropify/dist/css/dropify.min.css";
import "dropify/dist/js/dropify.min.js";
import $ from "jquery";

const AddWork = () => {
  const { id } = useParams();
  const isEditing = !!id;
  const [workName, setWorkName] = useState("");
  const [workImage, setWorkImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef();
  const navigate = useNavigate(); // Add useNavigate hook

  // Init Dropify on mount
  // useEffect(() => {
  //     $('.dropify').dropify();
  // }, []);

  // Fetch work details when editing
  useEffect(() => {
    if (isEditing) {
      axios
        .get(`/our-work/${id}`)
        .then((res) => {
          setWorkName(res.data.work_name);
          // console.log("Preview URL:", res.data.image_url); // ✅ this should now work
          setImagePreview(res.data.image_url);
        })

        .catch((err) => {
          console.error("Error loading work:", err);
          alert("Failed to load work details");
        });
    }
  }, [id, isEditing]);

  // Reinitialize Dropify with preview when editing
  useEffect(() => {
    if (isEditing && imagePreview) {
      const $input = $(fileInputRef.current);

      const drEvent = $input.data("dropify");
      if (drEvent) drEvent.destroy();

      $input.attr("data-default-file", imagePreview);

      setTimeout(() => {
        $input.dropify();
      }, 50);
    }
  }, [imagePreview, isEditing]);
  useEffect(() => {
    if (!isEditing) {
      const $input = $(fileInputRef.current);

      const drEvent = $input.data("dropify");
      if (drEvent) drEvent.destroy();

      $input.removeAttr("data-default-file");

      setTimeout(() => {
        $input.dropify();
      }, 50);
    }
  }, [isEditing]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setWorkImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // if (!workName) {
    //     alert("Work name is ");
    //     return;
    // }

    const formData = new FormData();
    formData.append("work_name", workName);
    if (workImage) formData.append("work_image", workImage);

    const request = isEditing
      ? axios.post(`/our-work/${id}?_method=PUT`, formData)
      : axios.post("/our-work", formData);

    request
      .then(() => {
        alert(
          isEditing
            ? "Image updated successfully!"
            : "Image added successfully!"
        );
        // window.location.href = "/admin/workList";
        navigate("/admin/workList");
      })
      .catch((err) => {
        console.error("Error saving work:", err.response?.data);
        alert("Failed to save work");
      });
  };

  return (
    <div className="main-content">
      <Link to="/admin/workList" className="text-decoration-none">
        <button className="btn text-black mb-3 border-0">
          <h5>
            ←
            <span className="ms-2">{isEditing ? "Edit Work" : "Add Work"}</span>
          </h5>
        </button>
      </Link>

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="form-label">
            Work Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter work name"
            value={workName}
            onChange={(e) => setWorkName(e.target.value)}
          />
        </div>

        <div className="mb-4">
          <label className="form-label">Cover Image</label>
          <input
            type="file"
            ref={fileInputRef}
            className="form-control dropify"
            onChange={handleImageChange}
            accept="image/*"
          />
        </div>

        <div className="text-end">
          <button
            type="submit"
            className="btn gold-add-btn py-2 px-4 w-auto rounded-0 text-white">
            {isEditing ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddWork;
